export const WARNING = {
  voyage: `La souscription à l'assurance voyage est exclusive aux résidents de Madagascar`,
  rapatriement: `La souscription à l'assurance obsèques à Dago est exclusive aux résidents en dehors de Madagascar`,
};
